// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ViewListSection_wrapper__xp0uv > * {\n  margin-bottom: 24px; }\n  .ViewListSection_wrapper__xp0uv > *:last-child {\n    margin-bottom: 0; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "ViewListSection_wrapper__xp0uv"
};
module.exports = exports;
